import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'email',
})
export class EmailPipe implements PipeTransform {
  transform(content): any {
    let parts = content.split('@');

    let s = parts[1].split(/\.(.+)/);

    return (
      parts[0] +
      '@' +
      s[0] +
      '<span class="email-extension">.' +
      s[1] +
      '</span>'
    );
  }
}
